import * as React from 'react';
import styled from 'styled-components';

import { type ContextMenuOption } from '@process-advisor/process-miner/api/methods/shared/contextMenu';
import { Option } from '@process-advisor/process-miner/components/contextMenu/option';

const StyledWrapper = styled.div`
    position: relative;

    &:hover > div {
        display: flex;
    }
`;

const StyledOptions = styled.div`
    display: none;
    flex-direction: column;

    border-radius: 4px;
    padding: 2px 0;
    position: absolute;
    left: 100%;
    top: 0;
`;

type Props = {
    contextMenuOptions: ContextMenuOption[],
    customKey: string,
    hideContextMenu: () => void,
}

export const Options = ({
    contextMenuOptions,
    customKey,
    hideContextMenu,
}: Props) => (
    <React.Fragment>
        {contextMenuOptions.map((menuOption, idx) => {
            const newCustomKey = `${customKey}@${menuOption.text.replace(/ /g, '')}`;
            const isFirst = idx === 0;
            const isLast = idx === contextMenuOptions.length - 1;
            if (menuOption.subMenuOptions) {
                return (
                    <StyledWrapper key={newCustomKey}>
                        <Option
                            isFirst={isFirst}
                            isLast={isLast}
                            isExpandable
                            text={menuOption.text} />
                        <StyledOptions>
                            <Options
                                hideContextMenu={hideContextMenu}
                                customKey={newCustomKey}
                                contextMenuOptions={menuOption.subMenuOptions} />
                        </StyledOptions>
                    </StyledWrapper>
                );
            }
            return (
                <Option
                    key={newCustomKey}
                    isFirst={isFirst}
                    isLast={isLast}
                    text={menuOption.text}
                    event={() => {
                        hideContextMenu();
                        menuOption.event && menuOption.event();
                    }} />
            );
        })}
    </React.Fragment>
);
